import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/about_2_tit_m_new.svg")